
import { RequestKindTypes, RequestSteps } from "@/models/request";
import { defineComponent, onUpdated, PropType, reactive } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Request Step",
  props: {
    kind: {
      type: String as PropType<RequestKindTypes>,
      required: true,
    },
    step: {
      type: Number as PropType<RequestSteps>,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      kind: props.kind,
      step: props.step,
    });

    const {t} = useI18n();

    const steps = reactive({
      tele: [t("select hopital and doctor"),t("select desired date/time"), t("chief complaint & files")],
      second: [t("select hopital and doctor"), t("chief complaint & files")],
    });

    onUpdated(() => {
      if (props.step === state.step) return;
      else state.step = props.step;
    });
    return { state, RequestKindTypes, steps };
  },
});
